import script from "./web-news.vue?vue&type=script&setup=true&lang=js"
export * from "./web-news.vue?vue&type=script&setup=true&lang=js"

import "./web-news.vue?vue&type=style&index=0&id=6d67fb46&lang=scss"

const __exports__ = script;

export default __exports__